module.exports = __webpack_public_path__ + "c_static/img/进入收藏夹提示.a7b91c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/进入收藏夹提示.jpg
// module id = DldC
// module chunks = 33